import { Link } from '@tanstack/react-router';

import { Button } from '@/components/ui/button';
import { landingContent } from '@/constants/landing-content';

const { finalCta } = landingContent;

export function FinalCtaSection() {
  return (
    <section className="from-primary/5 via-accent/30 to-secondary/5 bg-gradient-to-br py-16 md:py-24">
      <div className="container mx-auto max-w-4xl px-4 text-center">
        <h2 className="text-foreground text-3xl font-bold tracking-tight md:text-4xl lg:text-5xl">
          {finalCta.headline}
        </h2>

        <p className="text-muted-foreground mt-6 text-lg md:text-xl">
          {finalCta.subheadline}
        </p>

        <div className="mt-8">
          <Button asChild size="lg" className="px-8 py-6 text-base">
            <Link to="/registration">{finalCta.cta}</Link>
          </Button>
        </div>

        <p className="text-muted-foreground mt-6 text-sm">{finalCta.trust}</p>
      </div>
    </section>
  );
}
